import React from "react";

import { ActionRow } from "../../../common/action-row";

export interface ActionMenuProps {
  className?: string;
  title: string;
  description?: string;
  iconSrc?: string;
  disabled?: boolean;
  onClick: () => void;
}

/**
 * A single card action. Delegates to ActionRow so the card rows share the exact same appearance as
 * the account screen's quick actions, as they do on mobile.
 */
export const ActionMenu = (props: ActionMenuProps) => {
  const { title, description, iconSrc, className, disabled, onClick } = props;

  return (
    <ActionRow
      className={className}
      label={title}
      subtitle={description}
      iconSrc={iconSrc}
      disabled={disabled}
      onClick={onClick}
    />
  );
};
